import { registerPlugin } from '@capacitor/core';

const iosPlugin = registerPlugin('IOSPlugin');

export { iosPlugin };
